const storageKeyHodnoceni = 'storeRatingData-' + document.location.host;

function generateStars(score) {
  const full = Math.floor(score);
  const half = score % 1 >= 0.5;
  let html = '';

  for (let i = 0; i < full; i++) {
    html += '<span class="star star-on"></span>';
  }

  if (half && full < 5) {
    html += '<span class="star star-half"></span>';
  }

  return html;
}

let storeRatingCache = null;

// HTML banner .zc-promo ve výpisu kategorií (Shopcode bannery): skutečné hodnocení místo napevno napsaného
function renderPromoRating() {
  if (!storeRatingCache || !storeRatingCache.count) return; // bez dat nech v banneru napsané hodnoty
  const average = storeRatingCache.averageScore || 0;

  $('.zc-promo__score').html(`${average.toFixed(1).replace('.', ',')}<small>/ 5</small>`);
  $('.zc-promo__stars').html(generateStars(average));
  $('.zc-promo__count').text(`Na základě ${storeRatingCache.count || 0} hodnocení`);
}

// banner se do výpisu vkládá až po načtení stránky (a znovu po filtru, stránkování, "Načíst další")
document.addEventListener('ShopcodeBanneryVlozeny', renderPromoRating);

function renderRating(data) {
  const d = typeof data === 'string' ? JSON.parse(data) : data;
  const count = d.count || 0;
  const ratings = d.ratings?.slice(0, 4) || [];

  storeRatingCache = d;
  renderPromoRating();

  $('.reviewsHeader .stars').html(generateStars(d.averageScore || 0));
  $('.reviewsHeader .number').text(`${d.averageScore || 0} / 5`);
  $('.reviewsHeader .count .number').text(count);

  const reviewHtml = ratings
    .filter(r => (parseFloat(r.score) || 0) > 4)
    .map(r => {
      const date = formatAddedDate(r.created?.date);

      return `
        <div class="review-item">
          <div class="stars">${generateStars(parseFloat(r.score) || 0)}</div>
          <div class="description">${escapeHtml(r.description || '')}</div>

          <div class="info">
            <div class="name">${escapeHtml(r.fullName || '')}</div>
            <div class="date">${date}</div>
            <div class="verified">Ověřený nákup</div>
          </div>
        </div>
      `;
    })
    .join('');

  $('.reviews').html(reviewHtml);
}

/**
 * Vytáhne data z HTML stránky hodnocení.
 */
function scrapeStoreRating(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // Průměr, např. "5,0"
  const averageText =
    doc.querySelector('[data-testid="textRatingAverage"]')?.textContent?.trim() ||
    '0';

  const averageScore =
    parseFloat(averageText.replace(',', '.')) || 0;

  // Celkový počet hodnocení
  // primárně např. "6 hodnocení"
  const countText =
    doc.querySelector('.rate-average-inner .stars-label')?.textContent?.trim() ||
    doc.querySelector('.itemsTotal strong')?.textContent?.trim() ||
    '0';

  const countMatch = countText.match(/\d+/);
  const count = countMatch ? parseInt(countMatch[0], 10) : 0;

  const ratings = [];

  doc.querySelectorAll('#ratingsList .vote-wrap').forEach(vote => {
    // Pozor: .vote-wrap obsahuje hvězdy někdy 2x,
    // proto vezmeme jen jeden konkrétní blok.
    const stars =
      vote.querySelector('.vote-rating .stars') ||
      vote.querySelector(':scope > .stars');

    const score = stars
      ? stars.querySelectorAll('.star-on').length
      : 0;

    const fullName =
      vote.querySelector('[data-testid="textRatingAuthor"] span')?.textContent?.trim() ||
      vote.querySelector('.vote-name span')?.textContent?.trim() ||
      '';

    const description =
      vote.querySelector('[data-testid="textRating"]')?.textContent?.trim() ||
      vote.querySelector('.vote-content')?.textContent?.trim() ||
      '';

    const dateText =
      vote.querySelector('[data-testid="latestContributionDate"]')?.textContent?.trim() ||
      vote.querySelector('.vote-time')?.textContent?.trim() ||
      '';

    ratings.push({
      score,
      fullName,
      description,
      created: {
        date: convertCzechDate(dateText)
      }
    });
  });

  return {
    averageScore,
    count,
    ratings
  };
}

/**
 * "27.8.2026" -> "2026-08-27 00:00:00"
 *
 * Díky tomu může zůstat tvoje původní formatAddedDate().
 */
function convertCzechDate(value) {
  if (!value) return '';

  const match = value.match(
    /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/
  );

  if (!match) return value;

  const [, day, month, year] = match;

  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')} 00:00:00`;
}

/**
 * Pro jistotu escapujeme text recenze/jméno,
 * protože ho následně vkládáme přes .html().
 */
function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

async function loadStoreRating() {
  const stored = sessionStorage.getItem(storageKeyHodnoceni);

  if (stored) {
    try {
      // nulová data (hodnocení se nepodařilo načíst) se nikdy nepoužijí, zkusí se to znovu
      if (!JSON.parse(stored).count) throw new Error('Prázdná data hodnocení');
      renderRating(stored);
      return;
    } catch (e) {
      // Kdyby byla v sessionStorage stará/poškozená data
      sessionStorage.removeItem(storageKeyHodnoceni);
    }
  }

  let data = null;

  /*
   * 1. pokus – JSON endpoint
   */
  try {
    const request = await fetch('/cache/hodnoceni-obchodu/?jsonFormat', {
      headers: {
        'Accept': 'application/json',
        'X-Store-Rating-Details': 'true'
      }
    });

    if (!request.ok) {
      throw new Error(`HTTP ${request.status}`);
    }

    /*
     * Nepoužíváme request.json(), protože pokud server vrátí
     * HTML, vyhodí to okamžitě SyntaxError.
     *
     * Nejdřív si vezmeme text a JSON.parse() si ohlídáme sami.
     */
    const text = await request.text();

    try {
      data = JSON.parse(text);
    } catch (e) {
      console.warn(
        'JSON endpoint nevrátil validní JSON, používám HTML fallback.'
      );
    }

  } catch (error) {
    console.warn(
      'JSON endpoint se nepodařilo načíst, používám HTML fallback.',
      error
    );
  }

  /*
   * 2. pokus – HTML scrape
   */
  if (!data) {
    try {
      const request = await fetch('/cache/hodnoceni-obchodu/', {
        headers: {
          'Accept': 'text/html'
        }
      });

      if (!request.ok) {
        throw new Error(`HTTP ${request.status}`);
      }

      const html = await request.text();

      data = scrapeStoreRating(html);

    } catch (error) {
      console.error(
        'Chyba při načítání HTML hodnocení:',
        error
      );

      return;
    }
  }

  /*
   * Uložení výsledku – nezáleží, jestli přišel
   * z JSON API, nebo ze scrapovaného HTML.
   */
  if (data.count) {
    sessionStorage.setItem(
      storageKeyHodnoceni,
      JSON.stringify(data)
    );
  }

  renderRating(data);
}

function formatAddedDate(dateString) {
  if (!dateString) {
    return '';
  }

  const inputDate = new Date(dateString.replace(' ', 'T'));
  const now = new Date();

  if (Number.isNaN(inputDate.getTime())) {
    return '';
  }

  const diffMs = now - inputDate;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);

  if (diffDays < 7) {
    if (diffDays <= 1) return 'Přidáno dnes';
    return `Přidáno před ${diffDays} dny`;
  }

  if (diffDays < 30) {
    if (diffWeeks === 1) return 'Přidáno před týdnem';

    if (diffWeeks >= 2 && diffWeeks <= 4) {
      return `Přidáno před ${diffWeeks} týdny`;
    }
  }

  return 'Přidáno ' + inputDate.toLocaleDateString('cs-CZ', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

loadStoreRating();


if ($('#ratingsList .vote-wrap').length) {
  $('#ratingsList .vote-wrap').each(function () {
    const $vote = $(this);

    $vote.find('.stars').first().clone().prependTo($vote);

    if (!$vote.find('.vote-summary .verified').length) {
      $vote
        .find('.vote-summary')
        .append('<div class="verified">Ověřený nákup</div>');
    }
  });
}